module.exports = __webpack_public_path__ + "img/12-1_03.e183ccba.jpg";